import { DITypes } from "@/core/@types/types";
import { diContainer } from "@/di";
import { IStorage } from "./storage/Storage";

export default function useStorage() {
  const storageLib = diContainer.get<IStorage>(DITypes.STORAGE);

  return storageLib;
}
